import React from "react";
import { RouteGuard } from "../../../components/route-guard";
import { ADMIN_ROLES } from "../appRouteMatchers";
import { useAppContext } from "../../AppRootProviders";
import DashboardLayout from "../../../features/layout/DashboardLayout";

const AdminRouteLayout: React.FC = () => {
  const { user } = useAppContext();
  return (
    <RouteGuard allowedRoles={ADMIN_ROLES}>
      <DashboardLayout user={user || undefined} />
    </RouteGuard>
  );
};

export default AdminRouteLayout;
